import React from 'react';
import T from 'prop-types';
import { Tag } from 'antd';

import { useBreakpointsCtx } from '../../../../ctx/breakpointProvider';

import RequestBillingInfoData from '../../../requestBillingInfoData';
import Spinner from '../../../spinner';

import { StyledDescriptions } from './style';

const PlanDetails = ({ cardExpiration, cardNumber, isLoading, price, isCardDataEmpty }) => {
  const { isScreenMinMd } = useBreakpointsCtx();

  if (isLoading) {
    return <Spinner />;
  }

  const layout = isScreenMinMd ? 'horizontal' : 'vertical';

  return (
    <>
      {isCardDataEmpty && <RequestBillingInfoData />}

      <StyledDescriptions colon={!isScreenMinMd} layout={layout}>
        <StyledDescriptions.Item label="New Plan">
          <Tag color="red">Professional</Tag>
        </StyledDescriptions.Item>
        <StyledDescriptions.Item label="Price">{price}</StyledDescriptions.Item>
      </StyledDescriptions>

      <br />

      <StyledDescriptions colon={!isScreenMinMd} layout={layout}>
        <StyledDescriptions.Item label="Card Number">{cardNumber}</StyledDescriptions.Item>
        <StyledDescriptions.Item label="Expiry">{cardExpiration}</StyledDescriptions.Item>
      </StyledDescriptions>
    </>
  );
};

PlanDetails.propTypes = {
  isLoading: T.bool.isRequired,
  cardExpiration: T.string.isRequired,
  cardNumber: T.string.isRequired,
  price: T.string.isRequired,
  isCardDataEmpty: T.bool.isRequired,
};

export default PlanDetails;
